/* eslint-disable no-nested-ternary */
const getSurveyData = (state, eventHandlers) => {
  // Survey form render
  const visibleIfCondition = (rule, isPreview) =>
    rule.Conditions?.reduce((prev, curr) => {
      if (curr.Type === "form-validation") {
        // logic string for surveyjs
        return `${prev} ${curr.Order ? curr.Logical.toLowerCase() : ""} ({${curr.Options.find((opt) => opt.Type === "question")?.Value
          }} ${curr.Operator} ${
          // single value
          ([
            "=",
            "<>",
            "contains",
            "notcontains",
            ">",
            ">=",
            "<",
            "<=",
          ].includes(curr.Operator)
            ? `'${
                (curr.Options || []).find((opt) => opt.Type === "value")?.Value
              }'`
            : "") ||
          // multi value
          (["anyof"].includes(curr.Operator)
            ? `[${curr.Options.filter((opt) => opt.Type === "value")?.map(
              (opt) => `'${opt.Value}'`
            )}]`
            : "")
          })`;
      }
      // if preview, logic conditions are ignored

      if (isPreview === true) {
        return prev;
      }
      // logic conditions
      return `${prev} ${curr.Logical.toLowerCase()} [${curr.UUID}]`;
    }, "");

  const pages = [{ elements: [] }];

  [...(state.EventListeners || [])]
    ?.sort((a, b) => a.Order - b.Order)
    .filter((el) => el.EventType === "form-render")
    .map((el) => eventHandlers.find((eh) => eh.UUID === el.EventHandlerUUID))
    // event handler panels
    .forEach((eh) => {
      const panel = {
        type: "panel",
        name: eh?.UUID,
        elements:
          // rule panels
          eh?.Rules?.map((rule, index, rules) => ({
            type: "panel",
            name: rule.UUID,

            visibleIf: rules
              .slice(0, index)
              // get negative of previous conditions
              .reduce(
                (p, c) => [...p, `(!(${visibleIfCondition(c, false)}))`],
                rule.Conditions?.length > 0
                  ? [visibleIfCondition(rule, false)]
                  : []
              )
              .join(" and "),

            // for preview purposes, no logic conditions
            _visibleIf: rules
              .slice(0, index)
              // get negative of previous conditions
              .reduce(
                (p, c) => [...p, `(!(${visibleIfCondition(c, true)}))`],
                rule.Conditions?.length > 0
                  ? [visibleIfCondition(rule, true)]
                  : []
              )
              .join(" and "),

            elements: rule.Actions?.filter(
              (act) =>
                act.Type === "form-question" || act.Type === "form-message"
            ).map((act) => ({
              name: act.UUID,
              // type of question
              type:
                act.Type === "form-message"
                  ? "html"
                  : act.Options?.find((opt) => opt.Type === "Type")?.Value,
              // options

              // number validation
              ...(act.Options?.find((opt) => opt.Type === "Type")?.Value ===
                "text" &&
                act.Options?.find((opt) => opt.Type === "inputType")?.Value ===
                "number"
                ? {
                  validators: [
                    { type: "numeric", text: "Value must be a number" },
                  ],
                }
                : {}),
              // email validation
              ...(act.Options?.find((opt) => opt.Type === "Type")?.Value ===
                "text" &&
                act.Options?.find((opt) => opt.Type === "inputType")?.Value ===
                "email"
                ? {
                  validators: [
                    { type: "email", text: "Value must be a valid email" },
                  ],
                }
                : {}),

              // date input
              ...(act.Options?.find((opt) => opt.Type === "Type")?.Value ===
                "date"
                ? {
                  type: "text",
                  inputType: "date",
                  ...(act.Options?.find((opt) => opt.Type === "showPastDates")
                    ?.Value === "true" ? {} : { min: `[showPastDatesValue-${act.UUID}]` }),
                  ...(act.Options?.find((opt) => opt.Type === "showFutureDates")
                    ?.Value === "true" ? {} : { max: `[showFutureDatesValue-${act.UUID}]` }),
                  ...(act.Options?.find((opt) => opt.Type === "showPastDates")
                    ?.Value === "static"
                    ? {
                      _min:
                        act.Options?.find(
                          (opt) => opt.Type === "showPastDatesValue"
                        )?.ValueFrom === "static"
                          ? // new Date(
                          act.Options?.find(
                            (opt) => opt.Type === "showPastDatesValue"
                          )?.Value
                          : // )
                          //   .toISOString()
                          //   .split("T")[0]
                          "",
                    }
                    : act.Options?.find((opt) => opt.Type === "showPastDates")
                      ?.Value === "minusInterval"
                      ? {
                        _min:
                          act.Options?.find(
                            (opt) => opt.Type === "showPastDatesValue"
                          )?.ValueFrom === "static"
                            ? `=dateAdd(today(),-${act.Options?.find(
                              (opt) => opt.Type === "showPastDatesValue"
                            )?.Value
                            }, ${act.Options?.find(
                              (opt) => opt.Type === "showPastDatesUnit"
                            )?.Value
                            }s)`
                            : "",
                      }
                      : act.Options?.find((opt) => opt.Type === "showPastDates")
                        ?.Value === "false"
                        ? {
                          _min: "=today()",
                        }
                        : {}),
                  ...(act.Options?.find(
                    (opt) => opt.Type === "showFutureDates"
                  )?.Value === "static"
                    ? {
                      _max:
                        act.Options?.find(
                          (opt) => opt.Type === "showFutureDatesValue"
                        )?.ValueFrom === "static"
                          ? // new Date(
                          act.Options?.find(
                            (opt) => opt.Type === "showFutureDatesValue"
                          )?.Value
                          : // )
                          //   .toISOString()
                          //   .split("T")[0]
                          "",
                    }
                    : act.Options?.find(
                      (opt) => opt.Type === "showFutureDates"
                    )?.Value === "plusInterval"
                      ? {
                        _max:
                          act.Options?.find(
                            (opt) => opt.Type === "showFutureDatesValue"
                          )?.ValueFrom === "static"
                            ? `=dateAdd(today(),${act.Options?.find(
                              (opt) => opt.Type === "showFutureDatesValue"
                            )?.Value
                            }, ${act.Options?.find(
                              (opt) => opt.Type === "showFutureDatesUnit"
                            )?.Value
                            }s)`
                            : "",
                      }
                      : act.Options?.find(
                        (opt) => opt.Type === "showFutureDates"
                      )?.Value === "false"
                        ? {
                          _max: "=today()",
                        }
                        : {}),
                }
                : {}),

              // time input
              ...(act.Options?.find((opt) => opt.Type === "Type")?.Value ===
                "time"
                ? {
                  type: "text",
                  inputType: "time",
                  ...(act.Options?.find((opt) => opt.Type === "showPastTimes")
                    ?.Value === "true" ? {} : { min: `[showPastTimesValue-${act.UUID}]` }),
                  ...(act.Options?.find((opt) => opt.Type === "showFutureTimes")
                    ?.Value === "true" ? {} : { max: `[showFutureTimesValue-${act.UUID}]` }),

                  ...(act.Options?.find((opt) => opt.Type === "showPastTimes")
                    ?.Value === "static"
                    ? {
                      _min:
                        act.Options?.find(
                          (opt) => opt.Type === "showPastTimesValue"
                        )?.ValueFrom === "static"
                          ? // new Date(
                          act.Options?.find(
                            (opt) => opt.Type === "showPastTimesValue"
                          )?.Value
                          : // )
                          //   .toISOString()
                          //   .split("T")[1]
                          "",
                    }
                    : act.Options?.find((opt) => opt.Type === "showPastTimes")
                      ?.Value === "false"
                      ? {
                        _min: new Date().toISOString().split("T")[1],
                      }
                      : {}),
                  ...(act.Options?.find(
                    (opt) => opt.Type === "showFutureTimes"
                  )?.Value === "static"
                    ? {
                      _max:
                        act.Options?.find(
                          (opt) => opt.Type === "showFutureTimesValue"
                        )?.ValueFrom === "static"
                          ? // new Date(
                          act.Options?.find(
                            (opt) => opt.Type === "showFutureTimesValue"
                          )?.Value
                          : // )
                          //   .toISOString()
                          //   .split("T")[1]
                          "",
                    }
                    : act.Options?.find(
                      (opt) => opt.Type === "showFutureTimes"
                    )?.Value === "false"
                      ? {
                        _max: new Date().toISOString().split("T")[1],
                      }
                      : {}),
                }
                : {}),
              // rating input
              ...(act.Options?.find((opt) => opt.Type === "Type")?.Value ===
                "rating"
                ? {
                  rateMin: act.Options?.find((opt) => opt.Type === "RateMin")
                    ?.Value,
                  rateMax: act.Options?.find((opt) => opt.Type === "RateMax")
                    ?.Value,
                }
                : {}),
              // choices
              ...(["radiogroup", "checkbox", "dropdown", "tagBox"].includes(
                act.Options?.find((opt) => opt.Type === "Type")?.Value
              )
                ? {
                  choices:
                    // if the choices are static, use them directly
                    act.Options?.find((opt) => opt.Type === "Choice")
                      ?.ValueFrom === "static-options"
                      ? act.Options?.filter(
                        (opt) => opt.Type === "static-choice"
                      )
                        .sort((a, b) => a.Order - b.Order)
                        .map((opt) => opt.Value)
                      : // dynamic choices
                      `[choices-${act.UUID}]`,
                  _choices:
                    // if the choices are static, use them directly
                    act.Options?.find((opt) => opt.Type === "Choice")
                      ?.ValueFrom === "static-options"
                      ? act.Options?.filter(
                        (opt) => opt.Type === "static-choice"
                      )
                        .sort((a, b) => a.Order - b.Order)
                        .map((opt) => opt.Value)
                      : // dynamic choices
                      ["a", "b", "c"],

                  showOtherItem: act.Options?.find(
                    (opt) => opt.Type === "showOtherItem"
                  )?.Value,
                }
                : {}),
              ...(act.Type === "form-message"
                ? {
                  html: `<br>
                ${{
                      heading: "<h2>",
                      paragraph: "<p>",
                      alert: "<p class='alert alert-warning'>",
                    }[act.Options?.find((opt) => opt.Type === "HtmlType")?.Value]
                    }
                ${act.Options?.find((opt) => opt.Type === "HTML")?.Data}
                ${{
                      heading: "</h2>",
                      paragraph: "</p>",
                      alert: "</p>",
                    }[act.Options?.find((opt) => opt.Type === "HtmlType")?.Value]
                    }`,
                }
                : {}),
              title: act.Options?.find((opt) => opt.Type === "Title")?.Value,
              description: act.Options?.find(
                (opt) => opt.Type === "Description"
              )?.Value,
              isRequired: act.Options?.find((opt) => opt.Type === "IsRequired")
                ?.Value,
              minSelectedChoices: act.Options?.find(
                (opt) => opt.Type === "minSelectedChoices"
              )?.Value,
              defaultValue: act.Options?.filter(
                (opt) => opt.Type === "DefaultValue"
              ).map((opt) =>
                act.Options?.find((o) => o.Type === "DefaultValueType")
                  ?.Value === "inputArgument"
                  ? `[${opt.Value}]`
                  : opt.Value
              ),
              _defaultValue: act.Options?.filter(
                (opt) => opt.Type === "DefaultValue"
              ).map((opt) =>
                act.Options?.find((o) => o.Type === "DefaultValueType")
                  ?.Value === "inputArgument"
                  ? ``
                  : opt.Value
              ),
            })),
          })),
      };

      if (eh) {
        if (eh?.StopPropagation) {
          pages.push(panel);
        } else {
          pages[pages.length - 1].elements.push(panel);
        }
      }
    });

  const completedHtmlOnCondition = [];

  [...(state.EventListeners || [])]
    ?.sort((a, b) => a.Order - b.Order)
    .filter((el) => el.EventType === "form-render")
    .map((el) => eventHandlers.find((eh) => eh.UUID === el.EventHandlerUUID))
    // event handler panels
    .forEach((eh) => {
      eh?.Rules?.forEach((rule, index, rules) => {
        if (rule.Actions?.find((act) => act.Type === "form-complete-message")) {
          completedHtmlOnCondition.push({
            expression: rules
              .slice(0, index)
              // get negative of previous conditions
              .reduce(
                (p, c) => [...p, `(!(${visibleIfCondition(c, false)}))`],
                rule.Conditions?.length > 0
                  ? [visibleIfCondition(rule, false)]
                  : []
              )
              .join(" and "),
            _expression: rules
              .slice(0, index)
              // get negative of previous conditions
              .reduce(
                (p, c) => [...p, `(!(${visibleIfCondition(c, true)}))`],
                rule.Conditions?.length > 0
                  ? [visibleIfCondition(rule, true)]
                  : []
              )
              .join(" and "),
            html: rule.Actions?.find(
              (act) => act.Type === "form-complete-message"
            ).Options.find((opt) => opt.Type === "CompletedMessage")?.Data,
          });
        }
      });
    });

  const triggers = [];

  [...(state.EventListeners || [])]
    ?.sort((a, b) => a.Order - b.Order)
    .filter((el) => el.EventType === "form-render")
    .map((el) => eventHandlers.find((eh) => eh.UUID === el.EventHandlerUUID))
    // event handler panels
    .forEach((eh) => {
      eh?.Rules?.forEach((rule, index, rules) => {
        if (rule.Actions?.find((act) => act.Type === "form-complete-early")) {
          triggers.push({
            expression: rules
              .slice(0, index)
              // get negative of previous conditions
              .reduce(
                (p, c) => [...p, `(!(${visibleIfCondition(c, false)}))`],
                rule.Conditions?.length > 0
                  ? [visibleIfCondition(rule, false)]
                  : []
              )
              .join(" and "),
            _expression: rules
              .slice(0, index)
              // get negative of previous conditions
              .reduce(
                (p, c) => [...p, `(!(${visibleIfCondition(c, true)}))`],
                rule.Conditions?.length > 0
                  ? [visibleIfCondition(rule, true)]
                  : []
              )
              .join(" and "),
            type: "complete",
          });
        }
      });
    });

  return {
    ...state.SurveyJSON,
    completeText: state.SurveyJSON?.completeText || "Complete",
    showCompletedPage: "true",
    pages,
    completedHtmlOnCondition,
    triggers,
    width: "750px",
    fitToContainer: true,
    logoHeight: "100px",
    headerView: "advanced",
  };
};

export default getSurveyData;
